import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getAbout } from 'actions/about.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'

export interface AboutProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useAbout = (props: AboutProps) => {
  const dispatch = useAppDispatch()

  const homeAbout = useSelector((state: RootState) => state.about.homeAbout)

  const selectedLanguage = getLanguageFromUrl()

  useEffect(() => {
    if (!homeAbout) dispatch(getAbout())
  }, [homeAbout])

  return {
    ...props,
    homeAbout,
    selectedLanguage,
  }
}
